module.exports = __webpack_public_path__ + "img/kromnix-logo-main-dark-bg.a4b4c9ff.png";